import { router } from 'expo-router';
import { useEffect } from 'react';
import {
    Button,
    ButtonSize,
    ButtonVariant,
    CheckIcon,
    H2Emphasized,
    Icon,
    isWeb,
    ScreenContainer,
    View,
    YStack,
} from 'smoothie';

import LogRocketFacade from '../../../../../logger/log-rocket/LogRocketFacade';
import useGetPaymentSchedules from '../../../../hooks/useGetPaymentSchedules';
import { EBBankServicesDisclosure } from '../../../Disclosures';

const RecurringTransferSuccess = () => {
    LogRocketFacade.tagPage('RecurringTransferSuccess');

    const { refetch } = useGetPaymentSchedules({}, { enabled: false });

    useEffect(() => {
        void refetch();
    }, []);

    return (
        <ScreenContainer
            hasCloseButton
            onClose={() => {
                router.navigate('/home/banking');
            }}
        >
            <YStack justifyContent="space-between">
                <YStack alignItems="center">
                    <View
                        backgroundColor="$green1000"
                        borderRadius={12}
                        padding={16}
                        marginTop={isWeb ? 100 : '30%'}
                        marginBottom={18}
                    >
                        <Icon icon={CheckIcon} size={50} color="$white" />
                    </View>
                    <H2Emphasized>Transfer scheduled!</H2Emphasized>
                </YStack>
            </YStack>
            <View
                marginTop={isWeb ? 100 : 'auto'}
                $sm={{ width: 500, alignSelf: 'center' }}
            >
                <EBBankServicesDisclosure />
                <Button
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.LARGE}
                    text="Manage recurring transfers"
                    onPress={() => {
                        router.navigate('/banking/manage-recurring-transfers');
                    }}
                />
            </View>
        </ScreenContainer>
    );
};

export default RecurringTransferSuccess;
